








import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { default as OptionalFeatureEditor } from "./OptionalFeatureEditor.vue";

@Component({
  components: {
    OptionalFeatureEditor,
  },
})
export default class MultiLineBehaviorEditor extends Mixins(ModelEditableMixin) {
}
